if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super()
        this.input = this.querySelector(".quantity__input")
        this.currentVariant = this.querySelector(".product-variant-id")
        this.submitButton = this.querySelector('[type="submit"]')
      }

      cartUpdateUnsubscriber = undefined
      variantChangeUnsubscriber = undefined

      connectedCallback() {
        if (!this.input) return
        this.quantityForm = this.querySelector(".product-form__quantity")
        if (!this.quantityForm) return
        this.setQuantityBoundries()
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          )
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          if (event.data.sectionId !== sectionId) return
          this.updateQuantityRules(event.data.sectionId, event.data.html)
          this.setQuantityBoundries()
        })
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber()
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber()
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        }

        let min = data.min
        const max = data.max === null ? data.max : data.max - data.cartQuantity
        if (max !== null) min = Math.min(min, max)
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step)

        this.input.min = min
        this.input.max = max
        this.input.value = min
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined)
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return
        if (this.querySelector(".quantity__rules-cart .loading__spinner")) {
          this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden")
        }
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text()
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html")
            this.updateQuantityRules(this.dataset.section, html)
            this.setQuantityBoundries()
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            if (this.querySelector(".quantity__rules-cart .loading__spinner")) {
              this.querySelector(".quantity__rules-cart .loading__spinner").classList.add("hidden")
            }
          })
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`)
        const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"]
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector)
          const updated = quantityFormUpdated.querySelector(selector)
          if (!current || !updated) continue
          if (selector === ".quantity__input") {
            const attributes = ["data-cart-quantity", "data-min", "data-max", "step"]
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute)
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated)
            }
          } else {
            current.innerHTML = updated.innerHTML
          }
        }
      }
    }
  )
}

/* ADD TO CART TEST START */
window.addEventListener("load", function () {
  // eslint-disable-next-line no-prototype-builtins
  if (window.hasOwnProperty("atcTest")) {
    const targetNode = document.getElementById("rebuy-cart")
    const watchConfig = { attributes: true }

    const urlParams = new URLSearchParams(window.location.search)
    const discount = urlParams.get("discount")

    const watchRebuy = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
          if (window.atcTest === 1) {
            if (discount !== null && discount.length) {
              window.location.href = "/discount/" + discount + "?redirect=%2fcart"
            } else {
              window.location.href = "{{ routes.cart_url }}"
            }
          } else if (window.atcTest === 2) {
            if (discount !== null && discount.length) {
              window.location.href = "/discount/" + discount + "?redirect=%2fcheckout"
            } else {
              window.location.href = "/checkout/"
            }
          }
        }
      }
    }
    const observer = new MutationObserver(watchRebuy)
    observer.observe(targetNode, watchConfig)
  }
})
/* ADD TO CART TEST END */

document.addEventListener("DOMContentLoaded", function () {
  if (variantData.length === 1) {
    if (document.querySelector(".selector")) {
      document.querySelector(".selector").style.display = "none"
    }
    if (
      document.querySelector(".product-showcase") &&
      document.getElementById("product-variants")
    ) {
      var vs = new VariantSelects(document.getElementById("product-variants"))
      vs.currentVariant = variantData[0]
      vs.renderImages()
    }
  }

  document.addEventListener("click", function (event) {
    if (event.target.matches(".video-thumb")) {
      setTimeout(function () {
        document.querySelector(".product-media .slick-current").querySelector("video")[0].play()
      }, 300)
    }
  })

  function openModal(id) {
    const modal = document.querySelector(`.js-modal[data-id="${id}"]`)
    if (modal) {
      modal.classList.add("active")
      document.body.classList.add("overflow-hidden")
    }
  }

  function closeModal(e) {
    e.preventDefault()
    const modal = e.target.closest(".js-modal")
    modal.classList.remove("active")
    document.body.classList.remove("overflow-hidden")
  }

  document.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("nutritional") ||
      e.target.classList.contains("strength") ||
      e.target.classList.contains("detailsModalBtn1") ||
      e.target.classList.contains("strengthModalBtn1")
    ) {
      e.preventDefault()
      if (
        e.target.classList.contains("nutritional") ||
        e.target.classList.contains("detailsModalBtn1")
      ) {
        openModal("nutritional")
      } else if (
        e.target.classList.contains("strength") ||
        e.target.classList.contains("strengthModalBtn1")
      ) {
        openModal("strength")
      }
    }
  })

  document.querySelectorAll(".js-close").forEach((trigger) => {
    trigger.addEventListener("click", closeModal.bind(this))
  })
  document.querySelectorAll(".js-modal").forEach((modal) => {
    modal.classList.remove("hidden")
    modal.addEventListener("click", (event) => {
      if (!event.target.closest(".js-content")) closeModal(event)
    })
  })
})
